var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.09103 3.18205L7.27308 0L8.18205 0.908974L4.09103 5L0 0.908974L0.908974 0L4.09103 3.18205Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowDark);
export default __webpack_public_path__ + "static/media/downArrowDark.4c14841a9a00db38747f753d8f52b95b.svg";
export { ForwardRef as ReactComponent };